const { createSelector } = require('reselect')

// For Admin Panel
const selectPrescriptionList = state => state.prescriptions.prescriptionList

const getPrescriptionList = () => createSelector(
  [selectPrescriptionList],
  cse => cse.data,
)

const getPrescriptionListError = () => createSelector(
  [selectPrescriptionList],
  cse => cse.error,
)

const getPrescriptionListLoading = () => createSelector(
  [selectPrescriptionList],
  cse => cse.loading,
)

// For Admin Panel
const selectPrescription = state => state.prescriptions.prescription

const getPrescription = () => createSelector(
  [selectPrescription],
  cse => cse.data,
)

const getPrescriptionError = () => createSelector(
  [selectPrescription],
  cse => cse.error,
)

const getPrescriptionLoading = () => createSelector(
  [selectPrescription],
  cse => cse.loading,
)

// For Admin Panel
const selectCreate = state => state.prescriptions.create

const getCreatePrescription = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreatePrescriptionError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreatePrescriptionLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)

// For Admin Panel
const selectUpdate = state => state.prescriptions.update

const getUpdatePrescription = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdatePrescriptionError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdatePrescriptionLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)

// For Admin Panel
const selectDelete = state => state.prescriptions.delete

const getDeletePrescription = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeletePrescriptionError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeletePrescriptionLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

// For Admin Panel
const selectUpdatePresStatus = state => state.prescriptions.updatePrescriptionStatus

const getUpdatePrescriptionStatus = () => createSelector(
  [selectUpdatePresStatus],
  cse => cse.data,
)

const getUpdatePrescriptionStatusError = () => createSelector(
  [selectUpdatePresStatus],
  cse => cse.error,
)

const getUpdatePrescriptionStatusLoading = () => createSelector(
  [selectUpdatePresStatus],
  cse => cse.loading,
)

// For Admin Panel
const selectAddValidity = state => state.prescriptions.addPrescriptionValidity

const getAddPrescriptionValidity = () => createSelector(
  [selectAddValidity],
  cse => cse.data,
)

const getAddPrescriptionValidityError = () => createSelector(
  [selectAddValidity],
  cse => cse.error,
)

const getAddPrescriptionValidityLoading = () => createSelector(
  [selectAddValidity],
  cse => cse.loading,
)

const selectPrescriptionSearchValueState = state => state.prescriptions.doctorPrescriptionSearchValueState
const postPrescriptionSearchValueData = () => createSelector(
  [selectPrescriptionSearchValueState],
  cse => cse.data,
)
const postPrescriptionSearchValueLoading = () => createSelector(
  [selectPrescriptionSearchValueState],
  cse => cse.loading,
)
const postPrescriptionSearchValueError = () => createSelector(
  [selectPrescriptionSearchValueState],
  cse => cse.error,
)

const selectPrescriptionState = state => state.prescriptions.doctorPrescriptionState
const postPrescriptionListData = () => createSelector(
  [selectPrescriptionState],
  cse => cse.data,
)
const postPrescriptionListLoading = () => createSelector(
  [selectPrescriptionState],
  cse => cse.loading,
)
const postPrescriptionListError = () => createSelector(
  [selectPrescriptionState],
  cse => cse.error,
)

const selectGetPatientPrescriptionDataState = state => state.prescriptions.getPatientPrescriptionDataState
const getPatientPrescriptionData = () => createSelector(
  [selectGetPatientPrescriptionDataState],
  cse => cse.data,
)
const getPatientPrescriptionLoading = () => createSelector(
  [selectGetPatientPrescriptionDataState],
  cse => cse.loading,
)
const getPatientPrescriptionError = () => createSelector(
  [selectGetPatientPrescriptionDataState],
  cse => cse.error,
)

const selectMDPrescriptionNewLinkState = state => state.prescriptions.getMDPrescriptionNewLinkState
const selectMDPrescriptionNewLinkData = () => createSelector(
  [selectMDPrescriptionNewLinkState],
  cse => cse.data,
)
const selectMDPrescriptionNewLinkDataLoading = () => createSelector(
  [selectMDPrescriptionNewLinkState],
  cse => cse.loading,
)
const selectMDPrescriptionNewLinkDataError = () => createSelector(
  [selectMDPrescriptionNewLinkState],
  cse => cse.error,
)

// eslint-disable-next-line max-len
const selectEditPrescriptionSearchValueState = state => state.prescriptions.doctorEditPrescriptionSearchValueState
const getEditPrescriptionSearchValueData = () => createSelector(
  [selectEditPrescriptionSearchValueState],
  cse => cse.data,
)
const getEditPrescriptionSearchValueLoading = () => createSelector(
  [selectEditPrescriptionSearchValueState],
  cse => cse.loading,
)
const getEditPrescriptionSearchValueError = () => createSelector(
  [selectEditPrescriptionSearchValueState],
  cse => cse.error,
)

// eslint-disable-next-line max-len
const selectPostForPrescriptionNotificationState = state => state.prescriptions.postForPrescriptionNotificationState
const postForPrescriptionNotificationStateData = () => createSelector(
  [selectPostForPrescriptionNotificationState],
  cse => cse.data,
)
const postForPrescriptionNotificationStateDataLoading = () => createSelector(
  [selectPostForPrescriptionNotificationState],
  cse => cse.loading,
)
const postForPrescriptionNotificationStateDataError = () => createSelector(
  [selectPostForPrescriptionNotificationState],
  cse => cse.error,
)

module.exports = {
  // For Admin Panel
  getPrescriptionList,
  getPrescriptionListLoading,
  getPrescriptionListError,
  // For Admin Panel
  getPrescription,
  getPrescriptionLoading,
  getPrescriptionError,
  // For Admin Panel
  getCreatePrescription,
  getCreatePrescriptionLoading,
  getCreatePrescriptionError,
  // For Admin Panel
  getUpdatePrescription,
  getUpdatePrescriptionLoading,
  getUpdatePrescriptionError,
  // For Admin Panel
  getDeletePrescription,
  getDeletePrescriptionLoading,
  getDeletePrescriptionError,
  // For Admin Panel
  getUpdatePrescriptionStatus,
  getUpdatePrescriptionStatusError,
  getUpdatePrescriptionStatusLoading,
  // For Admin Panel
  getAddPrescriptionValidity,
  getAddPrescriptionValidityError,
  getAddPrescriptionValidityLoading,

  postPrescriptionSearchValueData,
  postPrescriptionSearchValueLoading,
  postPrescriptionSearchValueError,
  postPrescriptionListData,
  postPrescriptionListLoading,
  postPrescriptionListError,
  getPatientPrescriptionData,
  getPatientPrescriptionLoading,
  getPatientPrescriptionError,
  selectMDPrescriptionNewLinkData,
  selectMDPrescriptionNewLinkDataLoading,
  selectMDPrescriptionNewLinkDataError,

  getEditPrescriptionSearchValueData,
  getEditPrescriptionSearchValueLoading,
  getEditPrescriptionSearchValueError,

  postForPrescriptionNotificationStateData,
  postForPrescriptionNotificationStateDataLoading,
  postForPrescriptionNotificationStateDataError,
}
